<template>
  <main class="overview">
    <div class="overview__container">
      <ul class="overview__list">
        <li class="overview__item o-item o-item--radio">
          <span class="o-item__label-text o-item--radio__label-text">
            Weight unit
          </span>

          <label
            for="measurement_kg"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="KG"
              name="measurement"
              id="measurement_kg"
              v-model="measurement"
              type="radio" />
            <span
              class="o-item__text o-item--radio__text">
              KG
            </span>
          </label>

          <label
            for="measurement_lbs"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="LBS"
              id="measurement_lbs"
              v-model="measurement"
              type="radio" />
            <span
              class="o-item__text o-item--radio__text">
              LBS
            </span>
          </label>
        </li>

        <li class="overview__item o-item o-item--radio">
          <span class="o-item__label-text o-item--radio__label-text">
            Gender
          </span>

          <label
            for="gender_male"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="Male"
              name="gender"
              id="gender_male"
              v-model="gender"
              type="radio" />
            <span
              class="o-item__text o-item--radio__text">
              Male
            </span>
          </label>

          <label
            for="gender_female"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="Female"
              name="gender"
              id="gender_female"
              v-model="gender"
              type="radio" />
            <span
              class="o-item__text o-item--radio__text">
              Female
            </span>
          </label>
        </li>

        <li class="overview__item o-item o-item--number">
          <label
            for="bodyweight"
            class="o-item__label o-item--number__label">
            <span 
              class="o-item__label-text o-item--number__label-text"
              :class="{
                'o-item__label-text--active': !!(bodyweight),
                'o-item__label-text--error': error.type === 'bodyweight'
              }">
              Bodyweight
            </span>
            <input 
              class="o-item__input o-item--number__input"
              :class="{
                'o-item__input--error': error.type === 'bodyweight'
              }"
              type="number"
              id="bodyweight"
              value=""
              v-model.number="bodyweight"
              placeholder="75"
              name="bodyweight" />
          </label>
        </li>

        <li class="overview__item o-item o-item--radio">
          <span class="o-item__label-text o-item--radio__label-text">
            Calculate by
          </span>

          <label
            for="calculate_weight"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="Weight"
              name="calculate"
              id="calculate_weight"
              type="radio"
              v-model.number="calculate" />
            <span
              class="o-item__text o-item--radio__text">
              Total
            </span>
          </label>

          <label
            for="calculate_wilks"
            class="o-item__label o-item--radio__label">
            <input
              class="o-item__input o-item--radio__input"
              value="Wilks"
              name="calculate"
              id="calculate_wilks"
              type="radio"
              v-model.number="calculate" />
            <span
              class="o-item__text o-item--radio__text">
              Wilks
            </span>
          </label>
        </li>

        <li
          v-if="calculate === 'Weight'"
          class="overview__item o-item o-item--number">
          <label
            for="squat"
            class="o-item__label o-item--number__label">
            <span 
              class="o-item__label-text o-item--number__label-text"
              :class="{
                'o-item__label-text--active': !!(squat),
                'o-item__label-text--error': error.type === 'total'
              }">
              Squat
            </span>
            <input 
              class="o-item__input o-item--number__input"
              :class="{
                'o-item__input--error': error.type === 'total'
              }"
              type="number"
              id="squat"
              value=""
              v-model.number="squat"
              placeholder="140"
              name="squat" />
          </label>
        </li>

        <li
          v-if="calculate === 'Weight'"
          class="overview__item o-item o-item--number">
          <label
            for="bench"
            class="o-item__label o-item--number__label">
            <span 
              class="o-item__label-text o-item--number__label-text"
              :class="{
                'o-item__label-text--active': !!(bench),
                'o-item__label-text--error': error.type === 'total'
              }">
              Bench
            </span>
            <input 
              class="o-item__input o-item--number__input"
              :class="{
                'o-item__input--error': error.type === 'total'
              }"
              type="number"
              id="bench"
              value=""
              v-model.number="bench"
              placeholder="100"
              name="bench" />
          </label>
        </li>

        <li
          v-if="calculate === 'Weight'"
          class="overview__item o-item o-item--number">
          <label
            for="deadlift"
            class="o-item__label o-item--number__label">
            <span 
              class="o-item__label-text o-item--number__label-text"
              :class="{
                'o-item__label-text--active': !!(deadlift),
                'o-item__label-text--error': error.type === 'total'
              }">
              Deadlift
            </span>
            <input 
              class="o-item__input o-item--number__input"
              :class="{
                'o-item__input--error': error.type === 'total'
              }"
              type="number"
              id="deadlift"
              value=""
              v-model.number="deadlift"
              placeholder="180"
              name="deadlift" />
          </label>
        </li>

        <li
          v-if="calculate === 'Wilks'"
          class="overview__item o-item o-item--number">
          <label
            for="points"
            class="o-item__label o-item--number__label">
            <span 
              class="o-item__label-text o-item--number__label-text"
              :class="{
                'o-item__label-text--active': !!(points),
                'o-item__label-text--error': error.type === 'wilks'
              }">
              Points
            </span>
            <input 
              class="o-item__input o-item--number__input"
              :class="{
                'o-item__input--error': error.type === 'wilks'
              }"
              type="number"
              id="points"
              v-model.number="points"
              placeholder="350"
              name="points" />
          </label>
        </li>
      </ul>

      <p
        v-if="error.text"
        class="error">
        <span class="error__text">{{ error.text }}</span>
      </p>

      <template v-if="!error.text">
        <div
          class="overview__result overview__result--weight result"
          v-if="calculate === 'Weight'">
          <div class="result__label">
            Wilks
          </div>
          <div class="result__numbers">
            {{ calculatedWilks }}
          </div>
        </div>

        <div
          class="overview__result overview__result--wilks result"
          v-if="calculate === 'Wilks'">
          <div class="result__label">
            Total
          </div>
          <div class="result__numbers">
            {{ calculatedWeight }} {{ measurement }}
          </div>
        </div>
      </template>
    </div>
  </main>
</template>

<script>
import debounce from 'debounce'

export default {
  name: 'overview',
  data () {
    return {
      error: {
        text: 'Please fill in your bodyweight.',
        type: 'bodyweight'
      },
      measurement: 'KG',
      gender: 'Male',
      bodyweight: null,
      calculate: 'Weight',
      squat: null,
      bench: null,
      deadlift: null,
      points: null,
      calculatedWilks: null,
      calculatedWeight: 0
    }
  },
  methods: {
    debounce,
    baywatch: function (props, watcher) {
      var iterator = function (prop) {
        this.$watch(prop, watcher)
      }
      props.forEach(iterator, this)
    },
    coeff () {
      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        }
        return
      }

      // Reset the error
      this.error = {
        text: null,
        type: null
      }

      // Let's see what gender and measurement units we're going to use
      const gender = this.gender
      const measurement = this.measurement

      // Set the bodyweight based on the measurement units
      let bw = this.bodyweight
      if (measurement === 'LBS') {
        bw = bw / 2.2
      }

      // Set up all the constants for the formula
      const a = (gender === 'Male') ? -216.0475144 : 594.31747775582
      const b = (gender === 'Male') ? 16.2606339 : -27.23842536447
      const c = (gender === 'Male') ? -0.002388645 : 0.82112226871
      const d = (gender === 'Male') ? -0.00113732 : -0.00930733913
      const e = (gender === 'Male') ? 7.01863e-06 : 4.731582e-05
      const f = (gender === 'Male') ? -1.291e-08 : -9.054e-08

      // Coeff formula
      const coeff = 500 / (a + (b * bw) + (c * Math.pow(bw, 2)) + (d * Math.pow(bw, 3)) + (e * Math.pow(bw, 4)) + (f * Math.pow(bw, 5)))

      // Return the coeff
      return coeff
    },
    calculateWilks: debounce(function () {
      if (this.calculate !== 'Weight') {
        return
      }

      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        }
        return
      }

      // Not all are needed, but we need at least one of them
      if (!this.squat && !this.bench && !this.deadlift) {
        this.error = {
          text: 'Please fill in your lifted weights.',
          type: 'total'
        }
        return
      }

      // Get the total
      let total = Number(this.squat) + Number(this.bench) + Number(this.deadlift)

      // Reset the error
      this.error = {
        text: null,
        type: null
      }

      // Let's see what measurement unit we're going to use
      const measurement = this.measurement
      // Convert the total based on the measurement units
      if (measurement === 'LBS') {
        total = total / 2.2
      }

      // Coeff formula
      const coeff = this.coeff()
      const wilks = coeff * total

      // Return Wilks points
      this.calculatedWilks = wilks.toFixed(2)
    }, 100),
    calculateWeight: debounce(function () {
      if (this.calculate !== 'Wilks') {
        return
      }

      // We need the bodyweight to make the coeff calculation
      if (!this.bodyweight) {
        this.error = {
          text: 'Please fill in your bodyweight.',
          type: 'bodyweight'
        }
        return
      }

      // We need the desired Wilks points if we want to make the calculation
      if (!this.points) {
        this.error = {
          text: 'Please fill in your desired Wilks.',
          type: 'wilks'
        }
        return
      }

      // Reset the error
      this.error = {
        text: null,
        type: null
      }

      // Set the points constant
      const points = this.points

      // Coeff formula
      const coeff = this.coeff()

      // Total in KG
      let total = points / coeff

      // Let's see what measurement unit we're going to use
      const measurement = this.measurement
      // Convert the total based on the measurement units
      if (measurement === 'LBS') {
        total = total * 2.2
      }

      // Return the total
      this.calculatedWeight = total.toFixed(2)
    }, 100)
  },
  created () {
    this.baywatch(['bodyweight', 'measurement', 'gender', 'calculate', 'squat', 'bench', 'deadlift'], this.calculateWilks.bind(this))
    this.baywatch(['bodyweight', 'measurement', 'gender', 'calculate', 'points'], this.calculateWeight.bind(this))
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
  .overview{
    &__container{
      @include vw-size('padding-top', 37, 0, 1);
      @include vw-size('padding-bottom', 37, 0, 1);
      @extend %container;
    }
    &__list{
      padding:0;
      list-style-type:none;
      padding:0;
      margin:0;
      color: $c-lightpurple;
    }
  }

  .o-item{
    margin:0 0 1.2em;
    display:block;

    &__label{
      display:inline-block;
      cursor:pointer;
    }
    &__input{
      background-color:transparent;
      border-radius:none;
      box-shadow:none;
      border:0;
      appearance:none;
      padding:0;
      outline:0;

      &--error{
        border-color: $c-red !important;
        @include placeholder {
        }
      }
    }
    &__label-text{
      @include vw-size('font-size', 11.33, 0, 1);
      @include vw-size('width', 150, 0, 1);
      font-weight:$fw-medium;
      color:$c-lightblue;
      float:left;
      
      &--active{
      }
      &--error{
      }
    }

    &--radio{
      &__label + &__label{
        &:before{
          content:"/";
          color:$c-lightpurple !important;
        }
      }
      &__input{
        display:none;

        &:checked + .o-item__text{
          color: $c-white;
        }
      }
    }
    &--number{
      &__label-text{
        @include vw-size('padding-top', 7, 0, 1);
      }
      &__input{
        @include vw-size('max-width', 73, 0, 1);
        @include vw-size('padding-top', 7, 0, 1);
        @include vw-size('padding-bottom', 7, 0, 1);
        @include vw-size('padding-left', 10, 0, 1);
        @include vw-size('padding-right', 10, 0, 1);
        @include vw-size('border-radius', 2, 0, 1);
        color:$c-white;
        border:1px solid rgba(0,0,0,0.1);
        background-color: rgba(0,0,0,0.1);
        line-height: 1;
      }
    }
  }

  .result{
    @extend %clearfix;
    padding-top: 1.5em;
    border-top: 1px solid $c-lightblue;
    width: auto;
    display: inline-block;
    margin-top: .3em;

    &__label{
      @include vw-size('font-size', 11.33, 0, 1);
      @include vw-size('width', 150, 0, 1);
      font-weight:$fw-medium;
      color:$c-lightblue;
      float:left;
    }
    &__numbers{
      @include vw-size('margin-left', 150, 0, 1);
      display:block;
      color:$c-white;
    }
  }

  .error{
    @include vw-size('font-size', 14, 0, 1);
    margin: 4em 0 0;

    &__text{
      border-bottom:1px dashed;
      display:inline-block;
      color: $c-red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Overview/Overview.vue